import React from 'react';
import './SectionOurWork.scss';
import img from '../../../assets/images/vr-for-medical 1.png';
import { Button } from 'antd';
import CardWork from '../CardWork/CardWork';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
const SectionOurWork = ({ t, slider, data, isLoading }) => {
  const navigate = useNavigate();
  const { currentLang } = useSelector((state) => state.user);
  const dataWork = data;
  return (
    <section className="section-our-work" id="work">
      <div className="container">
        <div className="content">
          <div className="title-work">
            <div className="img-title"></div>
            <h1 className="title-our-work">{t.OurWork}</h1>
          </div>
          <p className="paragraph-our-work">{t.descriptionOurWork}</p>
          <CardWork
            t={t}
            data={dataWork}
            slider={slider}
            isLoading={isLoading}
          />
          <div
            className="btn-hero"
            style={{
              marginTop: '80px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Button
              className="btn-hero"
              type="primary"
              onClick={() =>
                navigate(
                  `${currentLang === 'en' ? '/projects' : '/ar/projects'}`
                )
              }
            >
              {t.Seeallprojects}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionOurWork;
